module.exports = __webpack_public_path__ + "static/media/card-empty.a095de58.svg";